import { Divider, Typography } from "@material-ui/core";
import { FormikProps } from "formik";
import React, { useState } from "react";
import ManagedLaboratoryResponse from "../../../../api/models/test-request/ManagedLaboratoryResponse";
import UserAction from "../../constants/UserAction";
import EditLabRelationsForm from "../EditLabRelationsForm/EditLabRelationsForm";
import { TableRowView } from "../NotificationsDialog/interfaces/TableRowView";
import NotificationsDialog from "../NotificationsDialog/NotificationsDialog";
import MultiSelectionTable from "./components/MultiSelectionTable/MultiSelectionTable";
import useStyles from "./LaboratoryPanelStyle";
import NotificationForm from "../NotificationForm/NotificationForm";

export interface LaboratoryPanelProps {
  laboratory: ManagedLaboratoryResponse;
  formRef: React.RefObject<
    FormikProps<{
      users: {
        id: number;
        name: string;
      }[];
    }>
  >;
  tabEdited: boolean;
  handleTabEdited: React.Dispatch<React.SetStateAction<boolean>>;
}

const LaboratoryPanel: React.FC<LaboratoryPanelProps> = (props: LaboratoryPanelProps) => {
  const classes = useStyles();
  const { laboratory, formRef, tabEdited, handleTabEdited } = props;
  const [action, setAction] = useState<UserAction>(UserAction.ADD);
  const [selectedRows, setSelectedRows] = useState<TableRowView[]>([]);
  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState(false);

  return (
    <>
      {isNotificationDialogOpen && (
        <NotificationsDialog
          open={isNotificationDialogOpen}
          action={action}
          laboratoryId={laboratory.id}
          notificationLists={selectedRows}
          handleDialogOpen={setIsNotificationDialogOpen}
        />
      )}
      <NotificationForm
        laboratoryId={laboratory.id}
        submittedRequestNotificationActive={laboratory.submittedRequestNotificationActive}
      />
      <Typography className={classes.assignmentSubHeader}>Managers</Typography>
      {laboratory.manager.length ? (
        laboratory.manager.map((m) => <Typography key={m.id}>{m.name}</Typography>)
      ) : (
        <Typography>This laboratory does not have any manager</Typography>
      )}
      <Divider className={classes.divider} />
      <Typography className={classes.assignmentSubHeader}>User Assignment</Typography>
      <Divider className={classes.divider} />
      <Typography>Assign users to laboratory. This can affect access to existing test requests.</Typography>
      <EditLabRelationsForm
        formRef={formRef}
        laboratoryId={laboratory.id}
        assignedUsers={laboratory.assignedUsers}
        tabEdited={tabEdited}
        handleTabEdited={handleTabEdited}
      />
      <Divider className={classes.divider} />
      <Typography className={classes.assignmentSubHeader}>Notification Lists</Typography>
      <Typography>Notification lists user management.</Typography>
      <MultiSelectionTable
        laboratoryId={laboratory.id}
        action={action}
        setAction={setAction}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        isNotificationDialogOpen={isNotificationDialogOpen}
        setIsNotificationDialogOpen={setIsNotificationDialogOpen}
      />
    </>
  );
};

export default LaboratoryPanel;
